// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AccNumberSchemaEnum,
  accNumberSchemaEnumFromJSON,
  accNumberSchemaEnumToJSON,
  StcsEntityStatusEnum,
  stcsEntityStatusEnumFromJSON,
  stcsEntityStatusEnumToJSON,
} from "./stcs_enums.entity";
import { StcsI18nLabelMap } from "./stcs_i18n.entity";

export const protobufPackage = "stcs_cmw";

export interface StcsCompList {
  entries: StcsComp[];
}

export interface StcsComp {
  id: string;
  data: StcsCompData | undefined;
  meta: StcsCompMeta | undefined;
  sandbox: boolean;
  version: string;
  i18n_map: { [key: string]: StcsI18nLabelMap };
}

export interface StcsComp_I18nMapEntry {
  key: string;
  value: StcsI18nLabelMap | undefined;
}

export interface StcsCompData {
  acc_number_schema: AccNumberSchemaEnum;
  cfg_logo_url: string;
  fpna_country: string;
  fpna_currency: string;
  display_name: string;
  fpna_fye_month: number;
  fpna_industry: number;
}

export interface StcsCompMeta {
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_user: string;
  ref_id_org: string;
  status: StcsEntityStatusEnum;
}

function createBaseStcsCompList(): StcsCompList {
  return { entries: [] };
}

export const StcsCompList: MessageFns<StcsCompList> = {
  encode(message: StcsCompList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      StcsComp.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(StcsComp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompList {
    return {
      entries: globalThis.Array.isArray(object?.entries) ? object.entries.map((e: any) => StcsComp.fromJSON(e)) : [],
    };
  },

  toJSON(message: StcsCompList): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => StcsComp.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompList>, I>>(base?: I): StcsCompList {
    return StcsCompList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompList>, I>>(object: I): StcsCompList {
    const message = createBaseStcsCompList();
    message.entries = object.entries?.map((e) => StcsComp.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStcsComp(): StcsComp {
  return { id: "", data: undefined, meta: undefined, sandbox: false, version: "", i18n_map: {} };
}

export const StcsComp: MessageFns<StcsComp> = {
  encode(message: StcsComp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.data !== undefined) {
      StcsCompData.encode(message.data, writer.uint32(18).fork()).join();
    }
    if (message.meta !== undefined) {
      StcsCompMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.sandbox !== false) {
      writer.uint32(40).bool(message.sandbox);
    }
    if (message.version !== "") {
      writer.uint32(34).string(message.version);
    }
    Object.entries(message.i18n_map).forEach(([key, value]) => {
      StcsComp_I18nMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsComp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsComp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = StcsCompData.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompMeta.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sandbox = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = StcsComp_I18nMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.i18n_map[entry8.key] = entry8.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsComp {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      data: isSet(object.data) ? StcsCompData.fromJSON(object.data) : undefined,
      meta: isSet(object.meta) ? StcsCompMeta.fromJSON(object.meta) : undefined,
      sandbox: isSet(object.sandbox) ? globalThis.Boolean(object.sandbox) : false,
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      i18n_map: isObject(object.i18n_map)
        ? Object.entries(object.i18n_map).reduce<{ [key: string]: StcsI18nLabelMap }>((acc, [key, value]) => {
          acc[key] = StcsI18nLabelMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsComp): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.data !== undefined) {
      obj.data = StcsCompData.toJSON(message.data);
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompMeta.toJSON(message.meta);
    }
    if (message.sandbox !== false) {
      obj.sandbox = message.sandbox;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.i18n_map) {
      const entries = Object.entries(message.i18n_map);
      if (entries.length > 0) {
        obj.i18n_map = {};
        entries.forEach(([k, v]) => {
          obj.i18n_map[k] = StcsI18nLabelMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsComp>, I>>(base?: I): StcsComp {
    return StcsComp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsComp>, I>>(object: I): StcsComp {
    const message = createBaseStcsComp();
    message.id = object.id ?? "";
    message.data = (object.data !== undefined && object.data !== null)
      ? StcsCompData.fromPartial(object.data)
      : undefined;
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompMeta.fromPartial(object.meta)
      : undefined;
    message.sandbox = object.sandbox ?? false;
    message.version = object.version ?? "";
    message.i18n_map = Object.entries(object.i18n_map ?? {}).reduce<{ [key: string]: StcsI18nLabelMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsI18nLabelMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsComp_I18nMapEntry(): StcsComp_I18nMapEntry {
  return { key: "", value: undefined };
}

export const StcsComp_I18nMapEntry: MessageFns<StcsComp_I18nMapEntry> = {
  encode(message: StcsComp_I18nMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsI18nLabelMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsComp_I18nMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsComp_I18nMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsI18nLabelMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsComp_I18nMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsI18nLabelMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsComp_I18nMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsI18nLabelMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsComp_I18nMapEntry>, I>>(base?: I): StcsComp_I18nMapEntry {
    return StcsComp_I18nMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsComp_I18nMapEntry>, I>>(object: I): StcsComp_I18nMapEntry {
    const message = createBaseStcsComp_I18nMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsI18nLabelMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompData(): StcsCompData {
  return {
    acc_number_schema: 0,
    cfg_logo_url: "",
    fpna_country: "",
    fpna_currency: "",
    display_name: "",
    fpna_fye_month: 0,
    fpna_industry: 0,
  };
}

export const StcsCompData: MessageFns<StcsCompData> = {
  encode(message: StcsCompData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.acc_number_schema !== 0) {
      writer.uint32(8).int32(message.acc_number_schema);
    }
    if (message.cfg_logo_url !== "") {
      writer.uint32(34).string(message.cfg_logo_url);
    }
    if (message.fpna_country !== "") {
      writer.uint32(42).string(message.fpna_country);
    }
    if (message.fpna_currency !== "") {
      writer.uint32(50).string(message.fpna_currency);
    }
    if (message.display_name !== "") {
      writer.uint32(58).string(message.display_name);
    }
    if (message.fpna_fye_month !== 0) {
      writer.uint32(72).uint32(message.fpna_fye_month);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(80).uint32(message.fpna_industry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.acc_number_schema = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cfg_logo_url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_country = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_currency = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.fpna_fye_month = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompData {
    return {
      acc_number_schema: isSet(object.acc_number_schema) ? accNumberSchemaEnumFromJSON(object.acc_number_schema) : 0,
      cfg_logo_url: isSet(object.cfg_logo_url) ? globalThis.String(object.cfg_logo_url) : "",
      fpna_country: isSet(object.fpna_country) ? globalThis.String(object.fpna_country) : "",
      fpna_currency: isSet(object.fpna_currency) ? globalThis.String(object.fpna_currency) : "",
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      fpna_fye_month: isSet(object.fpna_fye_month) ? globalThis.Number(object.fpna_fye_month) : 0,
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
    };
  },

  toJSON(message: StcsCompData): unknown {
    const obj: any = {};
    if (message.acc_number_schema !== 0) {
      obj.acc_number_schema = accNumberSchemaEnumToJSON(message.acc_number_schema);
    }
    if (message.cfg_logo_url !== "") {
      obj.cfg_logo_url = message.cfg_logo_url;
    }
    if (message.fpna_country !== "") {
      obj.fpna_country = message.fpna_country;
    }
    if (message.fpna_currency !== "") {
      obj.fpna_currency = message.fpna_currency;
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.fpna_fye_month !== 0) {
      obj.fpna_fye_month = Math.round(message.fpna_fye_month);
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompData>, I>>(base?: I): StcsCompData {
    return StcsCompData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompData>, I>>(object: I): StcsCompData {
    const message = createBaseStcsCompData();
    message.acc_number_schema = object.acc_number_schema ?? 0;
    message.cfg_logo_url = object.cfg_logo_url ?? "";
    message.fpna_country = object.fpna_country ?? "";
    message.fpna_currency = object.fpna_currency ?? "";
    message.display_name = object.display_name ?? "";
    message.fpna_fye_month = object.fpna_fye_month ?? 0;
    message.fpna_industry = object.fpna_industry ?? 0;
    return message;
  },
};

function createBaseStcsCompMeta(): StcsCompMeta {
  return { obj_created_iso_utc: "", obj_updated_iso_utc: "", ref_id_user: "", ref_id_org: "", status: 0 };
}

export const StcsCompMeta: MessageFns<StcsCompMeta> = {
  encode(message: StcsCompMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(10).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(26).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(34).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(42).string(message.ref_id_org);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompMeta {
    return {
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      status: isSet(object.status) ? stcsEntityStatusEnumFromJSON(object.status) : 0,
    };
  },

  toJSON(message: StcsCompMeta): unknown {
    const obj: any = {};
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.status !== 0) {
      obj.status = stcsEntityStatusEnumToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompMeta>, I>>(base?: I): StcsCompMeta {
    return StcsCompMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompMeta>, I>>(object: I): StcsCompMeta {
    const message = createBaseStcsCompMeta();
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.status = object.status ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
